import { CommonModule, formatDate } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { Store } from '@ngrx/store';
import {
    BehaviorSubject,
    combineLatest,
    firstValueFrom,
    from,
    Observable,
    of,
    ReplaySubject,
    Subject,
    Subscription,
} from 'rxjs';
import {
    distinctUntilChanged,
    filter,
    map,
    shareReplay,
    startWith,
    switchMap,
    take,
    takeUntil,
    tap,
    withLatestFrom,
} from 'rxjs/operators';
import {
    EventTypeNamesEnum,
    EventTypeNamesShortEnum,
    interruptionEventTypeNames,
} from '../dave-data-module/entities/event-type.entity';
import { EventEntity, EventStateEnum, EventStateEnumColorMap, EventStateEnumNameMap } from '../dave-data-module/entities/event.entity';
import { FileDataService } from '../dave-data-module/services/file-data.service';
import { State } from '../dave-data-module/State';
import { getEventTypes } from '../dave-data-module/State/selectors/event-type.selector';
import { getEvents, getEventsSortedByCreatedAt } from '../dave-data-module/State/selectors/events.selectors';
import { PdfEditorLegacyModule } from '../dave-dms-module/dave-dms/pdf-editor-legacy/pdf-editor-legacy.module';
// import { DaveEventListEntryModule } from "../dave-event-list-entry/dave-event-list-entry.module";
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource, MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Actions } from '@ngrx/effects';
import { FolderTypes } from '../dave-data-module/entities/folder.entity';
import { FolderDataService } from '../dave-data-module/services/folder-data.service';
import { HttpService } from '../dave-data-module/services/http.service';
import { BaseActionTypes } from '../dave-data-module/State/actions/base.actions';
import { CommissionActionTypes } from '../dave-data-module/State/actions/commission.actions';
import { EventsActionTypes } from '../dave-data-module/State/actions/events.actions';
import { getToken } from '../dave-data-module/State/selectors/base.selectors';
import { getCommissionById } from '../dave-data-module/State/selectors/commission.selector';
import { DaveEventListEntryModule } from '../dave-event-list-entry/dave-event-list-entry.module';
import { DaveLoadingPopupComponent, DaveLoadingPopupComponentDialogData } from '../dave-loading-popup/dave-loading-popup.component';
import { DaveSelectFileFromDmsComponent, DaveSelectFileFromDmsComponentDialogData, DaveSelectFileFromDmsComponentReturnData } from '../dave-select-file-from-dms/components/dave-select-file-from-dms/dave-select-file-from-dms.component';
import { AppButtonModule } from '../dave-utils-module/app-button-module/app-button.module';
import { DaveHeaderHeight, isNotNullOrUndefined, TableColumnConfig } from '../helper/helper';
import { LeafletWrapperComponent } from '../leaflet-wrapper/leaflet-wrapper.component';
import { PdfToolsService } from '../services/pdf-tools.service';
import { FileOrderDialogComponent, FileOrderDialogComponentDialogData, FileOrderDialogComponentDialogReturnData } from './components/file-order-dialog/file-order-dialog.component';
import { SelectFolderDialogComponent, SelectFolderDialogComponentDialogData, SelectFolderDialogComponentDialogReturnData } from '../dave-file-explorer/components/select-folder-dialog/select-folder-dialog.component';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { AppFilterModule } from '../dave-utils-module/app-filter-module/app-filter.module';
import { MatBadgeModule } from '@angular/material/badge';
import { FilterTypes } from '../services/default-filter.service';
import { FILTER_TYPE_SEARCH_MULTI_SELECT, FILTER_TYPE_TIMESPAN, FilterOption, IFilterTypeSearchMultiSelectValue } from '../dave-utils-module/app-filter-module/app-filter/app-filter.component';
import { Moment } from 'moment';
import { getFetched$ } from '../dave-data-module/helper/helper';
import { getSetting, getSettingFetched } from '../dave-data-module/State/selectors/users.selectors';
import { getPartner, getPartnerFetched } from '../dave-data-module/State/selectors/partners.selectors';
import { ChangeSettings } from '../dave-data-module/State/actions/settings.actions';
import { TableConfigFormComponent } from '../table-config-form/table-config-form.component';
import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import {
    selectEventCategories,
    selectEventCategoriesFetched,
} from '../dave-data-module/State/selectors/event-Categories.selector';
import { EventCategoriesActionTypes } from '../dave-data-module/State/actions/event-categories.actions';
import {
    CategoriesWithAssignments,
    EventCategoriesDataService,
} from '../dave-data-module/services/event-categories.service-data-service';
import { EventDataService } from '../dave-data-module/services/event.service-data-service';
import {EventResolver} from "../dave-data-module/guards/event.resolver";

export const LeafletMockPlanId = 625;
type eventTableData = Partial<EventEntity> & {
    color: string;
    typeShort: string;
    dateString: string;
};
@Component({
    selector: 'app-blueprint',
    standalone: true,
    imports: [
        CommonModule,
        PdfEditorLegacyModule,
        MatCardModule,
        /*DaveEventListEntryModule,*/ MatTabsModule,
        MatListModule,
        DaveEventListEntryModule,
        LeafletWrapperComponent,
        AppButtonModule,
        FontAwesomeModule,
        MatMenuModule,
        MatSidenavModule,
        MatTableModule,
        MatSortModule,
        MatTooltipModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        ReactiveFormsModule,
        AppFilterModule,
        MatBadgeModule,
        TableConfigFormComponent,
        DragDropModule,
    ],
    templateUrl: './blueprint.component.html',
    styleUrls: ['./blueprint.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlueprintComponent implements OnInit, OnDestroy {
    // @ViewChild('appPdfEditor') pdfEditor: PdfEditorComponent;
    @Input() CommissionId: number;
    @Input() expanded = false;
    @Output() EventMarkerClicked = new EventEmitter<EventEntity>();
    @Output() EventListEntryClicked = new EventEmitter<eventTableData>();
    @ViewChild(MatSort) private matSortDOM?: MatSort;
    @ViewChild('input') private inputRef?: ElementRef<HTMLInputElement>;
    @ViewChild('drawerContent') drawerContent: MatDrawer;
    @ViewChild('drawerCollumn') drawerCollumn: MatDrawer;

    // @ViewChild('leafletWrapperComponent') leafletWrapperComponent: LeafletWrapperComponent;

    protected listVisible = false;
    protected planViewDimension: number = 5000;
    public plans$: Observable<Array<{ documentId: number; documentName: string; imageUrl: string }>>;
    protected planSelected$ = new ReplaySubject<{ documentId: number; documentName: string; imageUrl: string }>(1);
    protected events$: Observable<EventEntity[]> = combineLatest([this.store.select(getEventsSortedByCreatedAt), this.store.select(getEventTypes)]).pipe(
        filter((v) => v.every(isNotNullOrUndefined)),
        map(([events, eventTypes]) => {
            const mangelTypes = eventTypes.filter((e) => interruptionEventTypeNames.includes(e.Name as EventTypeNamesEnum));
            return events.filter((e) => mangelTypes.some((mt) => mt.Id === e.EventTypeId) && e.CommissionId === this.CommissionId);
        }),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    public TableColumns: TableColumnConfig<eventTableData>[] = [
        { header: 'Id', name: 'Id' },
        { header: 'Name', name: 'Name' },
        { header: 'Typ', name: 'typeShort' },
        { header: 'Beschreibung', name: 'Description' },
        { header: 'Datum', name: 'dateString' },
        { header: 'Anhänge', name: 'FileCount' },
    ];
    private availableColumns: Array<keyof eventTableData> = ['Id', 'Name', 'typeShort', 'Description', 'dateString', 'FileCount'];
    public displayedColumns: string[];
    protected selectedColumns$: Observable<Array<keyof eventTableData>> = combineLatest([getFetched$(this.store, getSettingFetched, getSetting), getFetched$(this.store, getPartnerFetched, getPartner)]).pipe(
        map(([settings, partner]) => {
            if (settings.GeneratedDocumentListComponentDisplayedColumns) {
                return settings.GeneratedDocumentListComponentDisplayedColumns.map((k) => this.availableColumns.find((column) => column === k)).filter(isNotNullOrUndefined);
            } else if (partner.AdditionalData?.GeneratedDocumentListComponentDisplayedColumns) {
                return partner.AdditionalData.GeneratedDocumentListComponentDisplayedColumns.map((k) => this.availableColumns.find((column) => column === k)).filter(isNotNullOrUndefined);
            } else {
                return this.availableColumns;
            }
        }),
        shareReplay({ bufferSize: 1, refCount: true }),
    );
    public TableColumnsSorted$: Observable<TableColumnConfig<eventTableData>[]> = this.selectedColumns$.pipe(
        map((selected) => {
            return this.TableColumns.sort((a, b) => selected.indexOf(a.name) - selected.indexOf(b.name));
        }),
    );
    protected disabledColumns$ = combineLatest([this.TableColumnsSorted$, this.selectedColumns$]).pipe(map(([all, selected]) => {
        return all.length - selected.length || undefined
    }));
    public DataSource$: Observable<MatTableDataSource<eventTableData>>;
    public SearchBarActive = false;
    public SearchForm = new FormControl<string>('');
    public FilterValues$ = new BehaviorSubject<{
        [FilterTypes.EventType]: IFilterTypeSearchMultiSelectValue<number>[]
        [FilterTypes.Status]: IFilterTypeSearchMultiSelectValue<EventStateEnum>[]
        [FilterTypes.Date]: { to: Moment; from: Moment };
    }>({
        [FilterTypes.EventType]: [],
        [FilterTypes.Status]: [],
        [FilterTypes.Date]: { to: null, from: null },
    });
    public FilterSettings$: Observable<FilterOption[]> = combineLatest([
        this.store.select(getEventTypes),
        this.store.select(selectEventCategories).pipe(filter((categories): categories is CategoriesWithAssignments => !!categories),),
    ]).pipe(
        map(([eventTypes, categories]) => {
            const mangelTypes = eventTypes.filter((e) => interruptionEventTypeNames.includes(e.Name as EventTypeNamesEnum));
            const eventTypeFilterValues: IFilterTypeSearchMultiSelectValue[] = mangelTypes.map((e) => ({
                label: e.Name,
                id: e.Id,
            }));
            const EventStateOptions = Array.from(EventStateEnumNameMap.keys()).map((k) => ({ label: EventStateEnumNameMap.get(k), value: k }));
            const eventStatusFilterValues: IFilterTypeSearchMultiSelectValue[] = EventStateOptions.map((e) => ({
                label: e.label,
                id: e.value,
            }));
            const ret: FilterOption[] = [
                {
                    Name: FilterTypes.EventType,
                    Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                    Label: 'Typ',
                    Icon: null,
                    Values: eventTypeFilterValues,
                },
                {
                    Name: FilterTypes.Status,
                    Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                    Label: 'Status',
                    Icon: null,
                    Values: eventStatusFilterValues,
                },
                {
                    Name: FilterTypes.Date,
                    Type: FILTER_TYPE_TIMESPAN,
                    Label: 'Datum',
                    Icon: 'calendar',
                },
                {
                    Name: FilterTypes.EventCategory,
                    Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                    Label: 'Kategorie',
                    Values: categories.EventCategories.map<IFilterTypeSearchMultiSelectValue<string>>((category) => ({
                        id: category.Id.toString(),
                        label: category.Name,
                    })),
                }

            ];
            return ret;
        }),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    public FilterAmount$ = this.FilterValues$.pipe(map((filter) => {
        let count = 0;
        if (filter[FilterTypes.EventTypes]?.length) {
            count++;
        }
        if (filter[FilterTypes.EventCategory]?.length) {
            count++;
        }
        if (filter[FilterTypes.Status]?.length) {
            count++;
        }
        if (filter[FilterTypes.Date]?.from) {
            count++;
        }
        if (filter[FilterTypes.Date]?.to) {
            count++;
        }
        return count || null;
    }));
    private subscriptions: Subscription[] = [];
    constructor(
        protected fileDataService: FileDataService,
        protected store: Store<State>,
        protected api: HttpService,
        protected actions$: Actions,
        protected dialog: MatDialog,
        protected pdfToolsService: PdfToolsService,
        private folderDataService: FolderDataService,
        private eventCategoriesDataService: EventCategoriesDataService,
        private eventDataService: EventDataService,
        private eventRes: EventResolver,
    ) {}
    private resCategories$: Observable<CategoriesWithAssignments>



    ngOnInit(): void {
        this.resCategories$ = this.store.select(selectEventCategoriesFetched).pipe(
            switchMap((fetched) => {
                if (!fetched) {
                    this.store.dispatch(EventCategoriesActionTypes.Load({ Payload: {} }));
                    return from(this.eventCategoriesDataService.getRequest());
                }
                return this.store.select(selectEventCategories);
            }),
            shareReplay({ refCount: true, bufferSize: 1 }),
        );

        this.plans$ = this.store.select(getCommissionById({ id: this.CommissionId })).pipe(
            filter(isNotNullOrUndefined),
            map((commission) => commission.PlanIds),
            distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
            switchMap((ids) => (ids.length ? this.fileDataService.GetFilesById(ids).pipe(map((files) => ids.map((id) => files.find((f) => f?.Id === id)).filter(isNotNullOrUndefined))) : of([]))),
            withLatestFrom(this.store.select(getToken)),
            map(([files, token]) => files.map((f) => ({ documentId: f.Id, documentName: f.Name, imageUrl: this.api.GetUrl(f.GetLastVersion().GetDownloadLink(token), 'file') }))),
            distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
            tap((plans) => this.planSelected$.next(plans[0])),
            shareReplay({ refCount: true, bufferSize: 1 }),
        );

        this.DataSource$ = combineLatest([
            this.eventDataService.GetFromCommission$(this.CommissionId).pipe(map(events => this.eventDataService.FilterEvents(events))),
            this.plans$,
            this.FilterValues$,
            this.resCategories$
        ]).pipe(
            map(([events, plans, filter, resCategories ]) => {
                let filteredData = events;
                if (filter[FilterTypes.EventCategory]?.length) {
                    const categoryIds: number[] = filter[FilterTypes.EventCategory].map(c => Number(c.id));
                    const e2ec = resCategories.Event2EventCategories
                        .filter(event => categoryIds.includes(event.CategoryId))
                        .map(e => e.EventId);
                    filteredData =  filteredData.filter((d) =>  e2ec.includes(d.Id));
                }
                if (filter[FilterTypes.EventType]?.length) {
                    filteredData = filteredData.filter((d) => filter[FilterTypes.EventType].some((f) => f.id === d.EventTypeId));
                }
                if (filter[FilterTypes.Status]?.length) {
                    filteredData = filteredData.filter((d) => filter[FilterTypes.Status].some((f) => f.id === d.State));
                }
                if (filter[FilterTypes.Date]?.from) {
                    filteredData = filteredData.filter((d) => filter[FilterTypes.Date].from.isSameOrBefore(d.EventDate, 'day'));
                }
                if (filter[FilterTypes.Date]?.to) {
                    filteredData = filteredData.filter((d) => filter[FilterTypes.Date].to.isSameOrAfter(d.EventDate, 'day'));
                }
                return filteredData.filter((e) => e.AdditionalData?.mapMarker && plans.some((p) => !!e.AdditionalData.mapMarker[p.documentId]?.length))
            }),
            switchMap((events) => this.planSelected$.pipe(map((plan) => events.filter((e) => !!e.AdditionalData.mapMarker[plan.documentId]?.length)))),
        )
        .pipe(
            withLatestFrom(this.store.select(getEventTypes)),
            map(([events, eventTypes]) => {
                return new MatTableDataSource(events.map<eventTableData>((e) => {
                    const eventType =  eventTypes?.find((et) => et.Id === e.EventTypeId).Name;
                    var eventTypeShort: EventTypeNamesShortEnum;
                    switch(eventType) {
                        case EventTypeNamesEnum.Auffaeligkeit:
                            eventTypeShort = EventTypeNamesShortEnum.Auffaeligkeit;
                            break;
                        case EventTypeNamesEnum.Erschwernis:
                            eventTypeShort = EventTypeNamesShortEnum.Erschwernis;
                            break;
                        case EventTypeNamesEnum.Zusatzarbeit:
                            eventTypeShort = EventTypeNamesShortEnum.Zusatzarbeit;
                            break;
                        case EventTypeNamesEnum.Bedenkenanzeige:
                            eventTypeShort = EventTypeNamesShortEnum.Bedenkenanzeige;
                            break;
                        case EventTypeNamesEnum.Mangelanzeige:
                            eventTypeShort = EventTypeNamesShortEnum.Mangelanzeige;
                            break;
                        case EventTypeNamesEnum.Dokumentation:
                            eventTypeShort = EventTypeNamesShortEnum.Dokumentation;
                            break;
                        case EventTypeNamesEnum.Regiearbeit:
                            eventTypeShort = EventTypeNamesShortEnum.Regiearbeit;
                            break;
                        default:
                            eventTypeShort = null;
                    }
                    return {
                        ...e,
                        color: EventStateEnumColorMap.get(e.State),
                        typeShort: eventTypeShort,
                        dateString: formatDate(e.EventDate, 'dd.MM.yyyy', 'de-DE'),
                    }
                }))
            }),
            tap(
                (dataSource) =>
                    (dataSource.sortingDataAccessor = (object, key) => {
                        switch (key) {
                            case 'dateString':
                                return object.EventDate;
                            default:
                                return object[key];
                        }
                    }),
            ),
            switchMap(dataSource =>
                this.SearchForm.valueChanges.pipe(
                    startWith(''),
                    tap(searchTerm => (dataSource.filter = searchTerm.trim().toLowerCase())),
                    map(() => dataSource),
                ),
            ),
            shareReplay({ refCount: true, bufferSize: 1 }),
        );
        this.subscriptions.push(
            this.selectedColumns$.subscribe((columns) => {
                this.availableColumns = columns;
                this.displayedColumns = columns.slice();
            })
        )
    }
    ngOnDestroy(): void {
        this.subscriptions.forEach((s) => s.unsubscribe());
    }
    setEvents2(leafletWrapperComponent: LeafletWrapperComponent, planId: number) {

        this.DataSource$.pipe(
            map((dataSource) => dataSource.data as EventEntity[]),
            takeUntil(leafletWrapperComponent.OnDestroy$)
        ).subscribe((events) => {
            leafletWrapperComponent.clearMarkers();
            events.forEach((e) =>
                e.AdditionalData?.mapMarker[planId]?.forEach((m) =>
                    leafletWrapperComponent.addMarker(
                        Math.min(Math.max(m.top, 0), 1) ,
                        Math.min(Math.max(m.left, 0), 1),
                        undefined,
                        e.State ? EventStateEnumColorMap.get(e.State) : undefined,
                        () => {
                            leafletWrapperComponent.closeFullscreen();
                            this.EventMarkerClicked.emit(e);
                        },
                        { content: e.Name || e.EventNumber || e.Id.toString(), opacity: 1 },
                    ),
                ),
            );
        });
    }

    onFileUploadChange(replaceFileId?: number) {
        firstValueFrom(this.folderDataService.getFolderFromEntity(this.CommissionId, FolderTypes.commission)).then((folder)=> {
            this.dialog.open<SelectFolderDialogComponent, SelectFolderDialogComponentDialogData, SelectFolderDialogComponentDialogReturnData>(SelectFolderDialogComponent, {
                ...SelectFolderDialogComponent.DefaultConfig,
                data: {
                    ButtonText: 'HOCHLADEN',
                    matTreeNodePaddingIndent: 10,
                    uploadMode: true,
                    synchronUpload: true,
                    folderId: folder?.Id,
                    maxFilesUpload:1,
                },
            }).afterClosed().subscribe((res) => {
                if (res?.synchronUploadedDocuments?.length) {
                    this.fileHandler(res.synchronUploadedDocuments.map((f) => f.Id) , false, replaceFileId);
                }
            });
        });
        // if ((event.target as HTMLInputElement).files && (event.target as HTMLInputElement).files.length) {
        //     firstValueFrom(this.actions$.pipe(ofType(FilesActionTypes.UploadFileBackendSuccess, FilesActionTypes.UploadFileBackendFailure), bufferCount((event.target as HTMLInputElement).files.length))).then((actions) => {
        //         const ids = actions.filter((a) => a.type === FilesActionTypes.UploadFileBackendSuccess.type).map(({ Payload }) => (Payload as FileEntity).Id);
        //         if (ids.length) {
        //             // firstValueFrom(this.store.select(getCommissionById({ id: this.CommissionId }))).then((c) => {
        //             //     const additionalData = JSON.parse(JSON.stringify(c.AdditionalData || {}));
        //             //     additionalData.bluePrintIds = [...(additionalData.bluePrintIds || []), ...ids];
        //             //     this.store.dispatch(CommissionActionTypes.ModifyCommission({ Payload: { id: this.CommissionId, additionalData: JSON.stringify(additionalData) } }));
        //             // });
        //             this.fileHandler(ids, !fileId, fileId);
        //         }
        //     });
        //     for (const file of (event.target as HTMLInputElement).files) {
        //         this.store.dispatch(
        //             FilesActionTypes.UploadFileBackendRequest({
        //                 Payload: {
        //                     file: file,
        //                     params: new Map([
        //                         ['auto_set_folder', 'true'],
        //                         ['commission_id', JSON.stringify([this.CommissionId])],
        //                         ['metadata', JSON.stringify({ document_type: FileEntityDocumentTypes.blueprint })],
        //                     ]),
        //                 },
        //             }),
        //         );
        //     }
        // }
    }
    onStackOrderButtonClick() {
        firstValueFrom(this.plans$).then((plans) => {
            if (plans.length) {
                const dialogRef = this.dialog.open<FileOrderDialogComponent, FileOrderDialogComponentDialogData, FileOrderDialogComponentDialogReturnData>(FileOrderDialogComponent, {
                    data: {
                        fileIds: plans.map((p) => p.documentId),
                        withVersionUploadButton: true,
                        withDelete: true,
                        headline: 'Pläne',
                        searchPlaceholder: 'Pläne suchen',
                        deleteDialogData: {
                            paragraph: 'Wollen Sie den Plan wirklich aus der Liste entfernen ?',
                        },
                    },
                });
                dialogRef.componentInstance.versionUploadDms.pipe(takeUntil(dialogRef.afterClosed())).subscribe((fileId) => {
                    this.onDmsFileUploadClick(false, fileId);
                    dialogRef.close(null);
                });
                dialogRef.componentInstance.versionUpload.pipe(takeUntil(dialogRef.afterClosed())).subscribe((fileId) => {
                    this.onFileUploadChange(fileId);
                    dialogRef.close(null);
                });
                dialogRef.afterClosed().subscribe((result) => {
                    if (result) {
                        firstValueFrom(this.store.select(getCommissionById({ id: this.CommissionId }))).then((c) => {
                            if (JSON.stringify(c.PlanIds) !== JSON.stringify(result)) {
                                this.store.dispatch(CommissionActionTypes.ModifyCommission({ Payload: { id: this.CommissionId, planIds: result } }));
                                const removedFiles = plans.filter((p) => !result.includes(p.documentId));
                                if (removedFiles.length) {
                                    firstValueFrom(this.store.select(getEvents)).then((events) => {
                                        events
                                            .filter((e) => e.AdditionalData?.mapMarker && removedFiles.some((f) => e.AdditionalData.mapMarker[f.documentId]?.length))
                                            .forEach((e) => {
                                                const additionalData = JSON.parse(JSON.stringify(e.AdditionalData || {}));
                                                removedFiles.forEach((f) => {
                                                    delete additionalData.mapMarker[f.documentId];
                                                });
                                                this.store.dispatch(EventsActionTypes.ModifyEvent({ Payload: { id: e.Id, additionalData: JSON.stringify(additionalData) } }));
                                            });
                                    });
                                }
                            }
                        });
                    }
                });
            }
        });
    }

    onDmsFileUploadClick(multiplePages: boolean, fileId: number) {
        // if (this.fileDialog?.getState() === MatDialogState.OPEN) {
        //     this.fileDialog.close();
        // }
        firstValueFrom(this.folderDataService.getFolderFromEntity(this.CommissionId, FolderTypes.commission)).then((folder) => {
            /*this.fileDialog = */ this.dialog
                .open<DaveSelectFileFromDmsComponent, DaveSelectFileFromDmsComponentDialogData, DaveSelectFileFromDmsComponentReturnData>(DaveSelectFileFromDmsComponent, {
                    ...DaveSelectFileFromDmsComponent.DefaultConfig,
                    data: {
                        moveWarning: '',
                        maxFiles: 1,
                        preSelectedFiles: [],
                        folderId: folder?.Id,
                    },
                })
                .afterClosed()
                .subscribe((result) => {
                    if (result?.documents?.length) {
                        this.fileHandler(result.documents, multiplePages, fileId);
                    }
                });
        });
    }
    fileHandler(fileIds: number[], multiplePagesAllowed: boolean, replaceFileId?: number) {
        firstValueFrom(combineLatest([this.store.select(getCommissionById({ id: this.CommissionId })), this.fileDataService.GetFilesById(fileIds)])).then(async ([c, files]) => {
            const fileIdsToAdd = [];
            for (const f of files) {
                if (f.MIMEType.startsWith('image/')) {
                    await this.pdfToolsService.resizeImage({ VersionId: (f.GetLastVersion().Id).toString(), MaxDimension: this.planViewDimension.toString()}).then((res) => {
                        fileIdsToAdd.push(res !== null ? Number.parseInt(res.DocumentIds) : f.Id);
                    });
                } else if (f.MIMEType === 'application/pdf') {
                    const loadingDialog = this.dialog.open<DaveLoadingPopupComponent, DaveLoadingPopupComponentDialogData>(DaveLoadingPopupComponent, {
                        data: {
                            text: 'Ihre PDF wird konvertiert',
                            onReady$: new Subject<{ text: string; state: 'success' | 'fail' }>(),
                        },
                    });
                    await this.pdfToolsService.convertPDFToImage({ VersionId: (f.GetLastVersion().Id).toString(), OnlyOnePage: !multiplePagesAllowed, MaxDimension: (this.planViewDimension).toString() }).then((res) => {
                        if (!res.HasOnlyOnePage && !multiplePagesAllowed) {
                            loadingDialog.componentInstance.Data.onReady$.next({ text: 'Es sind nur PDF Dateien mit einer Seite erlaubt', state: 'fail' });
                            if (replaceFileId) {
                                fileIdsToAdd.push(replaceFileId);
                            }
                        } else {
                            const documentIds: number[] = res.DocumentIds.map((i) => Number(i));
                            loadingDialog.close();
                            fileIdsToAdd.push(...documentIds);
                        }
                    });
                } else {
                    this.store.dispatch(BaseActionTypes.ErrorAction({ Payload: { ToasterMessage: 'Nur PDF und Bilder erlaubt' } }));
                }
            }
            const replaceIndex = c.PlanIds.indexOf(replaceFileId);
            // const newPlanIds = replaceIndex > -1 ? c.PlanIds.slice().splice(replaceIndex, 1, ...fileIdsToAdd) : [...c.PlanIds, ...fileIdsToAdd];
            const newPlanIds = c.PlanIds.slice();
            if (replaceIndex > -1) {
                newPlanIds.splice(replaceIndex, 1, ...fileIdsToAdd);
            } else {
                newPlanIds.push(...fileIdsToAdd);
            }
            this.store.dispatch(
                CommissionActionTypes.ModifyCommission({
                    Payload: {
                        id: this.CommissionId,
                        planIds: newPlanIds,
                    },
                }),
            );
            if (replaceFileId) {
                if (fileIdsToAdd.length !== 1) {
                    throw new Error('replaceFileId only allowed for one file');
                }
                firstValueFrom(this.store.select(getEvents)).then((events) => {
                    events
                        .filter((e) => e.AdditionalData?.mapMarker && e.AdditionalData.mapMarker[replaceFileId]?.length)
                        .forEach((e) => {
                            const additionalData = JSON.parse(JSON.stringify(e.AdditionalData || {}));
                            const marker = additionalData.mapMarker[replaceFileId].slice();
                            delete additionalData.mapMarker[replaceFileId];
                            additionalData.mapMarker[fileIdsToAdd[0]] = marker;
                            this.store.dispatch(EventsActionTypes.ModifyEvent({ Payload: { id: e.Id, additionalData: JSON.stringify(additionalData) } }));
                        });
                });
            }
        });
    }

    onTableRowClick(row: eventTableData) {
        this.EventListEntryClicked.emit(row);
    }
    SearchButtonClicked() {
        if (!this.SearchBarActive) {
            this.SearchBarActive = true;
            setTimeout(() => this.inputRef?.nativeElement.focus(), 30);
        } else {
            if (this.SearchForm.value.length !== 0) {
                this.SearchForm.setValue("");
            }
            this.SearchBarActive = false;
        }
    }
    public SortTableData(sort: Sort) {
        this.subscriptions.push(
            this.DataSource$.subscribe((data) => {
                data.sort = this.matSortDOM;
                data.sort.active = sort.active
                data.sort.direction = sort.direction
            })
        )
    }
    drop(event: CdkDragDrop<string[]>) {
        if (event.previousIndex !== event.currentIndex) {
            const updatedColumns = [...this.availableColumns];
            moveItemInArray(updatedColumns, event.previousIndex, event.currentIndex);
            this.availableColumns = updatedColumns;
            this.displayedColumns = this.availableColumns.slice();
            this.saveColumnOrder();
        }
    }
    saveColumnOrder() {
        this.store.dispatch(
            new ChangeSettings({
                GeneratedDocumentListComponentDisplayedColumns: this.availableColumns,
            }),
        );
    }
    selectedColumnsChange(selectedColumns: Array<keyof eventTableData>) {
        this.store.dispatch(
            new ChangeSettings({
                GeneratedDocumentListComponentDisplayedColumns: selectedColumns,
            }),
        );
        this.availableColumns = selectedColumns;
        this.displayedColumns = selectedColumns.slice();
    }
    toggleTable(){
        this.listVisible = !this.listVisible
    }
    protected readonly DaveHeaderHeight = DaveHeaderHeight;
}
